import { GET_MEMBER_ID } from '../constants/signin';
import { GET_SETTING_VALUE_AUTH } from '../constants/system_master';
import { createApollo } from '../lib/apollo';

const client = createApollo();

const vuexModules = {
    namespaced: true,
    state: {
        loginMember: '',
        // Line連携の状態変更後のフラグを保持するために変数
        // loginMemberはLineフラグはキャッシュしてしまうため使えない
        loginMemberLineLinkFlag: '',
        lineOperationType: 'login',
        mobileAppFlag: mobileAppFlag, // モバイルアプリ判定フラグ
        mobileAppReserveNo: mobileReserveNo // モバイルアプリ用予約番号
    },
    getters: {
        loginMemberLineFlag: state => {
            // Line連携状態確認
            let lineFlag =
                state.loginMemberLineLinkFlag !== ''
                    ? state.loginMemberLineLinkFlag
                    : state.loginMember.line_link_flag;
            return lineFlag;
        }
    },
    mutations: {
        setLoginMember(state, loginMember) {
            state.loginMember = loginMember;
        },
        setLoginMemberLineLinkFlag(state, flag) {
            state.loginMemberLineLinkFlag = flag;
        },
        setLineOperationTypeFlag(state, flag) {
            state.lineOperationType = flag;
        },
        setLineSetting(state, flag) {
            state.settingValueLine = flag;
        },
        setWebReserveSetting(state, flag) {
            state.settingValueWebReserve = flag;
        },
        setChatboxSetting(state, flag) {
            state.settingValueChatbox = flag;
        },
        setMemberCodeNotSetting(state, flag) {
            state.settingValueMemberCodeNot = flag;
        }
    },
    actions: {
        async getLoginMember({ commit }) {
            await client
                .query({
                    query: GET_MEMBER_ID,
                    fetchPolicy: 'no-cache'
                })
                .then(res => {
                    commit(
                        'setLoginMemberLineLinkFlag',
                        res.data.getLoginMember.line_link_flag
                    );
                    commit('setLoginMember', res.data.getLoginMember);
                })
                .catch(error => {
                    commit('setLoginMember', '');
                    this.error = error;
                });
        },

        // システム設定・機能の利用有無を確認
        async getSettingValue({ commit }) {
            await client
                .query({
                    query: GET_SETTING_VALUE_AUTH,
                    fetchPolicy: 'no-cache'
                })
                .then(res => {
                    // LINE機能
                    commit(
                        'setLineSetting',
                        res.data.GetSettingValueAuth.lineSetting
                    );
                    // WEB予約機能
                    commit(
                        'setWebReserveSetting',
                        res.data.GetSettingValueAuth.reserveSetting
                    );
                    // Chatbox機能
                    commit(
                        'setChatboxSetting',
                        res.data.GetSettingValueAuth.chatboxSetting
                    );
                    // コードスキャン機能
                    commit(
                        'setMemberCodeNotSetting',
                        res.data.GetSettingValueAuth.memberCodeNotSetting
                    );
                })
                .catch(error => {
                    commit('setLineSetting', false);
                    commit('setWebReserveSetting', false);
                    commit('setChatboxSetting', false);
                    commit('setMemberCodeNotSetting', false);
                    this.error = error;
                });
        }
    }
};

export default vuexModules;
